export const camelCaseToSentenceCase = (input: string): string => {
    // Insert a space before all caps and convert to lowercase
    const sentenceCase = input.replace(/([A-Z])/g, ' $1').toLowerCase();
    
    // Capitalize the first letter and return the result
    return sentenceCase.charAt(0).toUpperCase() + sentenceCase.slice(1);
}